import $http from '$http'
import {
    lg,
    util
} from 'utils';

export default {
    methods: {
        getInfo(options) {
            let opts = $.extend({}, this.getErpConfig(), options);
            let Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: opts.id
            };
            this.TotalMoney = 0
            $http.get('api/Order/GetContractMoneyById', Params).then(res => {
                util.doResult(this, res, () => {
                    this.OrderData = res.data.Data;
                    this.auditFormData.OrderId = this.OrderData.OrderId;
                    for (let i = 0; i < this.OrderData.AreaNames.length; i++) {
                        this.TotalMoney += this.OrderData.AreaNames[i].ContractMoney
                    }
                });
            });
        },
        //审核确定
        auditConfirm(params) {
            $http.post('api/Order/ContractMoneyConfirmEx', params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '审核成功！',
                        type: 'success'
                    });
                    this.dialogVisible = false;
                    this.$emit('reLoadData');
                });
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/Order/voucherAudit/components/paymentAuditOrder/services.js